import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useExpertSupportMessageCreation } from "./ExpertSupportMessageCreationHook";
const ExpertSupportMessageCreationContext = /*#__PURE__*/createContext({});
export const ExpertSupportMessageCreationContextProvider = ({
  children
}) => {
  const expertSupportMessageCreation = useExpertSupportMessageCreation();
  const supportMessageValue = useMemo(() => ({
    ...expertSupportMessageCreation
  }), [expertSupportMessageCreation]);
  return /*#__PURE__*/React.createElement(ExpertSupportMessageCreationContext.Provider, {
    value: supportMessageValue
  }, children);
};
export const useExpertSupportMessageCreationContext = () => {
  return useContext(ExpertSupportMessageCreationContext);
};
ExpertSupportMessageCreationContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};